export class Cancelled extends Error {}
